module.exports = __webpack_public_path__ + "static/media/card-cirurgia.c9c5993b.svg";